import { Routes } from '@angular/router';
import { CardPaymentComponent } from './components/card-payment/card-payment.component';

export const routes: Routes = [{ path: 'payments/:token/:pkey', component: CardPaymentComponent }];

//TODO: Add 404 route
